// Auto-generated normalizer for table: ExamenPreguntas
export function examenPreguntasNormalize(row) {
  return {
    idExamenPregunta: row.idExamenPregunta ?? row.IdExamenPregunta ?? row['IdExamenPregunta'] ?? 0,
    idExamen: row.idExamen ?? row.IdExamen ?? row['IdExamen'] ?? 0,
    descripcionPregunta: row.descripcionPregunta ?? row.DescripcionPregunta ?? row['DescripcionPregunta'] ?? '',
    idTipoPregunta: row.idTipoPregunta ?? row.IdTipoPregunta ?? row['IdTipoPregunta'] ?? 0,
    idRespuestaCorrecta: row.idRespuestaCorrecta ?? row.IdRespuestaCorrecta ?? row['IdRespuestaCorrecta'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
